import dayjs from 'dayjs'
import { EMAIL_REGX } from '@utils/constants'

export const endTimeGreaterThanStartTime =
    (startNameField, message = 'The end time must be greater than start time.') =>
    ({ getFieldValue }) => ({
        validator(_, value) {
            if (!value) {
                return Promise.resolve()
            } else {
                if (value.diff(getFieldValue(startNameField), 'minutes') > 0) {
                    return Promise.resolve()
                } else {
                    return Promise.reject(message)
                }
            }
        }
    })

export const maximumRangeDays =
    limit =>
    ({}) => ({
        validator(_, value) {
            if (!value?.[0] || !value?.[1]) {
                return Promise.resolve()
            } else {
                const format = 'YYYY-MM-DD hh:mm AZ'
                let startDate = dayjs(value[0], format).startOf('day')
                const endDate = dayjs(value[1], format).startOf('day')
                let daysNumber = 0
                while (startDate.diff(endDate, 'day', true) <= 0) {
                    if (![6, 0].includes(startDate.weekday())) {
                        daysNumber++
                    }
                    startDate = startDate.add(1, 'days')
                }
                if (daysNumber <= limit) {
                    return Promise.resolve()
                } else {
                    return Promise.reject(`Date range must not exceed ${limit} days, excluding weekends.`)
                }
            }
        }
    })

export const endDateEqualOrGreaterThanStartDate =
    startNameField =>
    ({ getFieldValue }) => ({
        validator(_, value) {
            if (!value) {
                return Promise.resolve()
            } else {
                if (value.diff(getFieldValue(startNameField), 'days') < 0) {
                    return Promise.reject('The end date must be greater than or equal to start date.')
                } else {
                    return Promise.resolve()
                }
            }
        }
    })

export const endFullEndTimeGreaterThanFullStartTime = ({ getFieldValue }) => ({
    validator(_, value) {
        const startDate = dayjs(getFieldValue('startDate'), 'YYYY-MM-DD').format('YYYY-MM-DD')
        const startTime = dayjs(getFieldValue('startTime'), 'HH:mmZ').format('HH:mm')
        const fullStartDate = dayjs(startDate + ' ' + startTime, 'YYYY-MM-DD hh:mm AZ')
        const endDate = dayjs(getFieldValue('endDate'), 'YYYY-MM-DD').format('YYYY-MM-DD')
        const endTime = dayjs(getFieldValue('endTime'), 'HH:mmZ').format('HH:mm')
        const fullEndDate = dayjs(endDate + ' ' + endTime, 'YYYY-MM-DD hh:mm AZ')

        if (!value || fullEndDate.diff(fullStartDate, 'minutes') > 0) {
            return Promise.resolve()
        } else {
            return Promise.reject('The end time must be greater than start time.')
        }
    }
})
export const maxValueEqualOrGreaterThanMinValue =
    minFieldName =>
    ({ getFieldValue }) => ({
        validator(_, value) {
            if (!value) {
                return Promise.resolve()
            } else {
                if (value >= getFieldValue(minFieldName)) {
                    return Promise.resolve()
                } else {
                    return Promise.reject('The maximum value must be equal or greater than minimum value.')
                }
            }
        }
    })

export const emailRule = {
    email: {
        format: {
            pattern: EMAIL_REGX,
            message: `^${'Please enter valid email address'}`
        },
        presence: {
            message: `^${"Email can't be blank"}`
        }
    }
}
